module.exports.ALL_INSTANCES = 'ALL_INSTANCES';
